/* eslint-disable react/forbid-elements */
import * as React from 'react';

export const CommunicationErrorIllustration: React.FC = () => {
  return (
    <svg viewBox="0 0 340 216" height="100%" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#a)">
        <path fill="#fff" d="M340 0H0v216h340z" />
        <path
          d="m122.261 174.472-2.457 40.703-65.236.606s-24.306-8.779-27.695-43.546c-4.786-49.06 42.452-83.659 66.84-87.775 13.207-2.23 20.893.776 26.979 2.294 14.349 3.582 38.358 2.124 56.193-8.474 10.42-6.19 25.346-9.535 46.415-5.203 17.414 3.579-30.355 51.337-30.355 51.337l8.401 91.371h-87.881"
          fill="#006CFD"
        />
        <path
          d="m122.261 174.472-2.457 40.703-65.236.606s-24.306-8.779-27.695-43.546c-4.786-49.06 42.452-83.659 66.84-87.775 13.207-2.23 20.893.776 26.979 2.294 14.349 3.582 38.358 2.124 56.193-8.474 10.42-6.19 25.346-9.535 46.415-5.203 17.414 3.579-30.355 51.337-30.355 51.337l8.401 91.371h-87.881"
          stroke="#006CFD"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M233.125 147.453h-2.089c-3.436 0-6.596 1.843-8.246 4.802l-29.849 53.624 3.329 7.761 36.855-66.187z"
          fill="#fff"
        />
        <path d="m192.941 205.879 29.849-53.624c1.647-2.959 4.81-4.802 8.246-4.802h2.089" fill="#fff" />
        <path
          d="m192.941 205.879 29.849-53.624c1.647-2.959 4.81-4.802 8.246-4.802h2.089"
          stroke="#031D40"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M288.781 215.556h-93.562l37.909-68.103h93.562l-37.909 68.103zM192.797 205.263h-59.282c-2.896 0-5.242 2.303-5.242 5.146 0 2.844 2.346 5.147 5.242 5.147h61.702l-2.42-10.293z"
          fill="#fff"
          stroke="#031D40"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M338.72 215.018H.996"
          stroke="#031D40"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M173.552 171.735c0 8.209-1.421 30.094-9.542 31.291-5.954.878-5.684-5.041-5.684-5.041" fill="#fff" />
        <path d="M163.202 172.931s-2.184 30.737-10.555 30.784c-6.322.036-5.428-5.73-5.428-5.73" fill="#fff" />
        <path
          d="M152.237 174.525s-2.633 31.467-11.773 29.1c-6.498-1.683-2.586-10.459-1.826-13.352 1.826-6.976.813-11.36.813-11.36"
          fill="#fff"
        />
        <path
          d="M169.699 197.66s2.437 5.965 7.307 1.197c4.871-4.769 9.239-23.891 3.045-35.553-8.121-15.288-45.098-15.288-45.098-15.288l-10.609 36.637 15.405-3.142 9.728 16.381"
          fill="#fff"
        />
        <path
          d="M135.219 148.129s36.977 0 45.098 15.288c6.194 11.662 1.826 30.783-3.044 35.552-4.871 4.769-7.308-1.196-7.308-1.196"
          stroke="#031D40"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M173.822 171.847c0 8.209-1.421 30.095-9.542 31.291-5.954.879-5.684-5.04-5.684-5.04"
          stroke="#031D40"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M163.467 173.044s-2.184 30.737-10.554 30.784c-6.323.036-5.428-5.73-5.428-5.73"
          stroke="#031D40"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M152.505 174.638s-2.633 31.466-11.773 29.1c-6.494-1.683-2.586-10.459-1.826-13.352 1.826-6.976.813-11.36.813-11.36M124.609 184.765l15.406-3.141M85.336 145.339h49.105l-14.636 58.704"
          stroke="#031D40"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M126.594 19.88s-7.145-2.558-11.229 2.35c-4.085 4.908-1.313 10.568 3.598 12.583" fill="#fff" />
        <path
          d="M126.594 19.88s-7.145-2.558-11.229 2.35c-4.085 4.908-1.313 10.568 3.598 12.583"
          stroke="#031D40"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M135.462 10.743s-7.146-2.558-11.23 2.35c-4.084 4.908-1.313 10.569 3.598 12.584" fill="#fff" />
        <path
          d="M135.462 10.743s-7.146-2.558-11.23 2.35c-4.084 4.908-1.313 10.569 3.598 12.584"
          stroke="#031D40"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M195.707 16.437S160.67 4.887 142.696 5.96c-6.2.372-9.008 4.09-9.008 8.034.003 11.8 15.459 7.536 15.459 7.536"
          fill="#fff"
        />
        <path
          d="M195.707 16.437S160.67 4.887 142.696 5.96c-6.2.372-9.008 4.09-9.008 8.034.003 11.8 15.459 7.536 15.459 7.536M182.412 69.766l-13.596-4.71"
          stroke="#031D40"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m215.686 82.187-46.874-17.13 26.892-48.623s24.293 6.313 46.273 22.459c46.496 34.154 22.504 75.784-7.942 84.142-28.039 7.695-56.075 14.164-56.075 14.164"
          fill="#006CFD"
        />
        <path
          d="m215.686 82.187-46.874-17.13 26.892-48.623s24.293 6.313 46.273 22.459c46.496 34.154 22.504 75.784-7.942 84.142-28.039 7.695-56.075 14.164-56.075 14.164"
          stroke="#006CFD"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="m200.727 78.207-31.915-13.15M130.223 70.124s10.447 6.541 23.53 0c8.045-4.02 11.547-11.642 12.301-16.046.862-5.034.386-8.6-.004-11.428-2.061-14.846-10.537-22.602-25.456-21.803-22.781 1.223-22.817 22.677-22.817 22.677s-5.998-.825-6.689 3.566c-.93 5.903 4.934 6.898 4.934 6.898L109 85.385s10.968 10.995 30.853 10.995c16.531 0 27.059-7.506 27.059-7.506s-1.392-22.186-1.392-32.65"
          stroke="#031D40"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M146.804 42.197s-.957 2.605-.653 3.407c.303.802 4.717 5.758 4.391 7.653-.326 1.895-6.796.46-6.796.46M139.764 61.714c-.373 1.38.226 3.093 2.327 4.167 1.503.768 6.531.79 6.425-3.377-.102-4.172-7.595-5.042-8.752-.79zM131.484 42.196s2.771-4.375 8.176-3.989M152.605 38.986s4.934-1.016 8.176 2.542"
          stroke="#031D40"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M117.734 42.865s3.074-.527 5.459-3.508c4.024-5.038 3.827-10.311 3.827-10.311s23.696 12.139 43.98-7.354c0 0-12.048-13.651-35.621-7.194-13.484 3.695-20.274 17.595-17.645 28.367z"
          fill="#031D40"
          stroke="#031D40"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <ellipse cx="137.614" cy="45.541" rx="2.044" ry="2.007" fill="#152242" />
        <ellipse cx="156.009" cy="45.541" rx="2.044" ry="2.007" fill="#152242" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" transform="matrix(-1 0 0 1 340 0)" d="M0 0h340v216H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
